import {
  call,
  put,
  select,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { urlSearchSelector } from '../../../../selectors/router';
import { requestIfNecessaryLanguages } from '../../../../sagas/signin';
import { displayPendingReviews } from '../../../../sagas/appointments';
import { spawnChronosSigninFormToastr } from '../../../../services/Chronos';
import { afterSigninNavigation } from '../utils/afterSigninNavigation';

/*
 * @param { Credentials } - With optionally .password and .email
 * @param { UserModel } - should respond to .type
 */
export function* handleSpecialUsersSignin(credentials, user) {
  if (user.profiles.length > 1) {
    if(credentials.password && credentials.email) {
      yield call(spawnChronosSigninFormToastr, user, credentials);
    }
  }
}

/**
 *
 * @param {Object} routingParams
 */
export function* processAfterSignin(routingParams) {
  yield call(requestIfNecessaryLanguages);
  yield call(displayPendingReviews);

  // when redirect path is in url
  const search = yield select(urlSearchSelector);
  if (search?.redirect) {
    yield put(push(search?.redirect));
    return;
  }

  const routingResult = afterSigninNavigation(routingParams);
  if(routingResult) {
    yield put(push(routingResult));
  }
}
